// extracted by mini-css-extract-plugin
export default {"subtitle":"question_subtitle__EhqAO","number":"question_number__eak-b","headerWrapper":"question_headerWrapper__BGGx1","itemName":"question_itemName__pnQPN"};